import { create } from 'zustand'
import { setStaffSessionToken } from '../services/api'

// #995 スタッフモードのセッション。owner(Firebase) とは別軸で、店ごとの共有ログイン
// コード＋個人PIN で得た署名済みトークンを保持する。~12h で失効（exp）。
export interface StaffSession {
  token: string
  storeId: string
  memberId: string
  name: string
  role: 'manager' | 'staff'
  exp: number // UNIX 秒
}

const KEY = 'staffSession'

function loadSession(): StaffSession | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const s = JSON.parse(raw) as StaffSession
    // exp 失効 or 壊れたデータは破棄（fail-closed）。
    if (!s?.token || !s.exp || s.exp * 1000 <= Date.now()) {
      localStorage.removeItem(KEY)
      return null
    }
    return s
  } catch {
    return null
  }
}

interface StaffAuthState {
  session: StaffSession | null
  setSession: (s: StaffSession) => void
  clearSession: () => void
}

const initial = loadSession()
// 起動時に有効セッションがあれば api の token を復元。
if (initial) setStaffSessionToken(initial.token)

export const useStaffAuth = create<StaffAuthState>((set) => ({
  session: initial,
  setSession: (s) => {
    localStorage.setItem(KEY, JSON.stringify(s))
    setStaffSessionToken(s.token)
    set({ session: s })
  },
  clearSession: () => {
    localStorage.removeItem(KEY)
    setStaffSessionToken(null)
    set({ session: null })
  },
}))
